import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { Paintbrush } from 'lucide-react';

import { useEffect, useState } from 'react';
import ColorPicker from 'react-pick-color';

interface ColorPickerProps {
  onValueChange: (value: string) => void;
  label?: string;
  defaultColor: string;
}
export function ColorPickerCustom({
  onValueChange,
  label,
  defaultColor,
}: ColorPickerProps) {
  const [background, setBackground] = useState(defaultColor || '');

  useEffect(() => {
    if (defaultColor) {
      setBackground(defaultColor);
    }
  }, [background]);

  return (
    <div className='space-y-2 flex flex-col w-full'>
      <Label htmlFor=''>{label}</Label>
      <GradientPicker
        onValueChange={onValueChange}
        background={background}
        setBackground={setBackground}
      />
    </div>
  );
}

export function GradientPicker({
  background,
  onValueChange,
  className,
  setBackground,
}: {
  background: string;
  setBackground: (background: string) => void;
  className?: string;
  onValueChange: (value: string) => void;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild className='w-full'>
        <Button
          variant={'outline'}
          className={cn(
            'flex w-full justify-start text-left font-normal',
            !background && 'text-muted',
            className
          )}
        >
          <div className='w-full flex items-center gap-2'>
            {background ? (
              <div
                className='h-4 w-4 rounded !bg-center !bg-cover transition-all'
                style={{ background }}
              ></div>
            ) : (
              <Paintbrush className='h-4 w-4' />
            )}
            <div className='truncate flex-1'>
              {background ? background : 'Pick a color'}
            </div>
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto'>
        <ColorPicker
          color={background}
          onChange={(color) => {
            onValueChange(color.hex);
            setBackground(color.hex);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
